export const QUERY_KEYS = {
  USER: 'user',
  COMMERCIAL_SUPPLIERS: 'commercialSuppliers',
  COMMERCIAL_SUPPLIER_DETAIL: 'commercialSupplierDetail',
  TICKETS: 'tickets',
  TICKET: 'ticket',
  CARRIERS: 'carriers',
  ALL_CARRIERS: 'allCarriers',
  SUPPLIERS: 'suppliers',
  CONTRACTS: 'contracts',
  CONTRACTS_ALL: 'allContracts',
  DESTINATIONS: 'destinations',
  DESTINATIONS_FILTERED: 'destinationsFiltered',
  MATERIALS: 'materials',
  CARRIER_EQUIPMENT: 'carrierEquipment',
  TRUCK_DOCUMENTATION: 'truckDocumentation',
  RAILCAR_DOCUMENTATION: 'railcarDocumentation',
  INVOICES_BY_TICKET_ID: 'invoicesByTicketId',
  INVOICES_BY_DATE: 'invoicesByDate',
  TICKETS_COUNT: 'ticketsCount',
  CONFIGURATION_PROPERTIES: 'configurationProperties',
  CARRIER_TICKETS_COUNT: 'carrierTicketsCount',
  ALLBORDERS: 'allBorderCrossings',
  USERBORDERS: 'userBorderCrossings',
  PURCHASES: 'purchaseOrders',
  DELIVERY_NOTES: 'sapItemSupplierDeliveryNote',
  RPA: 'RPA',
  PENDINGS: 'PENDINGS',
  NOTIFICATIONS: 'notifications',
  TO_AUTHORIZE: 'TO_AUTHORIZE',
  CONTRACTS_UPDATE: 'contractsUpdate',
  CONTRACTS_SYNC: 'CONTRACTS_SYNC',
  CONTRACTS_FILTERS: 'contractsFilters',
  UPLOAD_BULK_DATA_HISTORY: 'uploadBulkDataHistory',
  ROUTES: 'routes',
  ROUTES_ALL: 'allRoutes',
  ROUTES_FILTERS: 'routesFilters',
  ROUTES_ASNUMS: 'routesAsnums',
  SIMULATION: 'simulation',
  GROUPS_MATERIAL: 'groupsMaterial',
  SEARCHED_TICKET: 'searchedTicket',
  UPLOAD_TICKET_FILES: 'uploadTicketFiles',
  GET_TICKET_FILE_URL: 'getTicketFileUrl',
  DOWNLOAD_TICKET_FILE: 'downloadTicketFile',
  TICKETS_SUPPLIERS: 'suppliersTickets',
  TRUCKS: 'trucks',
  CARRIER_TRUCKS: 'carrier_trucks',
  CARRIER_TRAILERS: 'carrier_trailers',
  DRIVERS: 'drivers',
  CARRIER_DRIVERS: 'carrier_drivers',
  TELEPHONE_PREFIXES: 'telephone_prefixies',
  BILLING_BATCH: 'billing_batch',
  CONFIGURATIONS: 'configurations',
  TRAILER: 'trailer',
  CARRIER_AVAILABILITY: 'carrier_availability',
  CARRIERS_AVAILABILITY_SUMMARY: 'carriers_availability_summary',
  VEHICLES_ADMIN: 'vehicles_admin',
  DRIVERS_ADMIN: 'drivers_admin',
  TRAILERS_ADMIN: 'trailers_admin',
  CARRIERS_ADMIN: 'carriers_admin',
  SUPPLIERS_ADMIN: 'suppliers_admin',
  DEPOT: 'depot_admin',
  SAP_GEO: 'sap_geo',
  MGMTS: 'mgmts',
  CONTRACTS_SUPPLIER: 'contract_supplier',
  ASSIGNMENT_ZONES: 'assignment_zones',
  ORDERS: 'orders',
  ORDERS_FILTERS: 'ordersFilters',
  ORDERS_ASNUMS: 'ordersAsnums',
  ORDERS_UPDATE: 'ordersUpdate',
  ORDER_NUMBER: 'orderNumber',
  SIMULATION_TICKET_ADMIN: 'simulation_ticket_admin',
  CONTRACTS_BY_CARRIER: 'contracts_by_carrier',
  METRICS_WEEKLY: 'metricsWeekly',
  METRICS_DAILY: 'metricsDaily',
  METRICS_MONTHLY: 'metricsMonthly',
  METRICS_MONTHLY_COMPLIANCE_BY_ZONE: 'metricsMonthlyComplianceByZone',
  METRICS_MONTHLY_SUPPLIERS: 'metricsMonthlySuppliers',
  CARRIER_QUOTA_CONFIG: 'carrierQuotaConfig',
}
